const protocol = window.location.protocol; // http: or https:

// BASE_URL = `${protocol}//shreevaibhavlaxmimahilaurban.in/backend`;
const BASE_URL = `${protocol}//shreegruhlaxmiurban.in/backend`;
// const BASE_URL = `http://192.168.1.103/shreegruhlaxmiurban.in/backend`;

export default BASE_URL;
